import styled, { css } from 'styled-components';

import { brandSpecificNavBorderStyle } from './mobile-web-navigation-border.styled';

const mobileCss = css<{ bannerHeight: string }>`
  padding-bottom: env(safe-area-inset-bottom);
  bottom: 0;
`;
export const MobileWebNavigationBorder = styled.div<{ $bottomInset: number; bannerHeight: string }>`
  background: ${Styles.color.white};
  border-top: 1px solid ${Styles.color.grey.three};
  bottom: 0;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: ${Styles.zIndex.overlay};
  transition: padding 0.05s ease-in-out;
  padding-bottom: ${props => props.$bottomInset}px;
  ${Styles.mobile`
    ${mobileCss}
  `}
  ${Styles.mobileLandscape`
    ${mobileCss}
  `}
  ${Styles.desktop`
    display: none;
  `}
  ${brandSpecificNavBorderStyle}
`;
